module.exports = __webpack_public_path__ + "dist/media/ec_comp_social_follow.9681f38c.svg";